import classes from "./Skills.module.scss";

import Html from "../../images/html.svg";
import Css from "../../images/css.svg";
import Bootstrap from "../../images/bootstrap.svg";
import Javascript from "../../images/javascript.svg";
import Nextjs from "../../images/nextjs.svg";
import Python from "../../images/python.svg";
import Sass from "../../images/sass.svg";
import ReactJS from "../../images/reactjs.svg";
import Redux from "../../images/redux.svg";

import Html_light from "../../images/html_light.svg";
import Css_light from "../../images/css_light.svg";
import Bootstrap_light from "../../images/bootstrap_light.svg";
import Javascript_light from "../../images/javascript_light.svg";
import Nextjs_light from "../../images/nextjs_light.svg";
import Python_light from "../../images/python_light.svg";
import Sass_light from "../../images/sass_light.svg";
import ReactJS_light from "../../images/reactjs_light.svg";
import Redux_light from "../../images/redux_light.svg";

const skills = [
  {
    image: Nextjs,
    name: "NextJS",
  },
  {
    image: ReactJS,
    name: "ReactJS",
  },
  {
    image: Redux,
    name: "Redux",
  },
  {
    image: Javascript,
    name: "Javascript",
  },
  {
    image: Css,
    name: "CSS",
  },
  {
    image: Html,
    name: "HTML",
  },
  {
    image: Sass,
    name: "SASS",
  },
  {
    image: Bootstrap,
    name: "Bootstrap",
  },
  {
    image: Python,
    name: "Python",
  },
];

const skills_light = [
  {
    image: Nextjs_light,
    name: "NextJS",
  },
  {
    image: ReactJS_light,
    name: "ReactJS",
  },
  {
    image: Redux_light,
    name: "Redux",
  },
  {
    image: Javascript_light,
    name: "Javascript",
  },
  {
    image: Css_light,
    name: "CSS",
  },
  {
    image: Html_light,
    name: "HTML",
  },
  {
    image: Sass_light,
    name: "SASS",
  },
  {
    image: Bootstrap_light,
    name: "Bootstrap",
  },
  {
    image: Python_light,
    name: "Python",
  },
];

const Skills = (props) => {
  const { isDark } = props;
  return (
    <div className={classes.skills} is="skills">
      <div className={classes.skills_heading}>Skills & Known Languages</div>
      <div className={classes.skills_container}>
        {isDark
          ? skills.map((skill, index) => (
              <div
                className={classes.slide}
                key={index}
                style={{
                  border: isDark
                    ? "1px solid rgba(254, 254, 254, 0.12)"
                    : "1px solid rgba(203, 92, 230, 0.52)",
                  boxShadow: isDark
                    ? "#090916 0px -22px 70px 4px, #090916 0px 22px 70px 4px"
                    : "#fefefe 0px -22px 70px 4px, #fefefe 0px 22px 70px 4px",
                  backgroundColor: isDark ? "#090916" : "#fefefe",
                }}
              >
                <img src={skill.image} alt={skill.name} />
                <div
                  className={classes.slide_intro}
                  style={{
                    border: isDark
                      ? "1px solid rgba(254, 254, 254, 0.12)"
                      : "1px solid rgba(203, 92, 230, 0.52)",
                    backgroundColor: isDark ? "#090916" : "#fefefe",
                  }}
                >
                  {skill.name}
                </div>
              </div>
            ))
          : skills_light.map((skill, index) => (
              <div
                className={classes.slide}
                key={index}
                style={{
                  border: isDark
                    ? "1px solid rgba(254, 254, 254, 0.12)"
                    : "1px solid rgba(203, 92, 230, 0.52)",
                  boxShadow: isDark
                    ? "#090916 0px -22px 70px 4px, #090916 0px 22px 70px 4px"
                    : "#fefefe 0px -22px 70px 4px, #fefefe 0px 22px 70px 4px",
                  backgroundColor: isDark ? "#090916" : "#fefefe",
                }}
              >
                <img src={skill.image} alt={skill.name} />
                <div
                  className={classes.slide_intro}
                  style={{
                    border: isDark
                      ? "1px solid rgba(254, 254, 254, 0.12)"
                      : "1px solid rgba(203, 92, 230, 0.52)",
                    backgroundColor: isDark ? "#090916" : "#fefefe",
                  }}
                >
                  {skill.name}
                </div>
              </div>
            ))}
      </div>
    </div>
  );
};

export default Skills;
